/**
 * Подсказки поля «Интересы» (владелец 20.10): сначала интересы, которые уже
 * стоят в наших группах объявлений (во всех кабинетах), потом — поиск по
 * справочнику Meta. Новый интерес из Meta добавить можно всегда.
 */
export const USED_INTERESTS_GROUP = 'Уже использовали';
export const META_INTERESTS_GROUP = 'Ещё из Meta';
/** Сколько «уже использованных» показывать (и на пустом вводе, и при поиске). */
export const USED_INTERESTS_SHOWN = 20;
/** С какой длины запроса идём в Meta. */
export const META_SEARCH_MIN_CHARS = 2;
const norm = (s) => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru-RU');
/** Совпадение «уже использованного» с вводом: подстрока названия или начало id. */
export function usedInterestMatches(row, query) {
    const q = norm(query);
    return q === '' || norm(row.name).includes(q) || row.id.startsWith(q);
}
/**
 * Секции списка: «Уже использовали» (по убыванию числа групп, не больше
 * {@link USED_INTERESTS_SHOWN}) и «Ещё из Meta» (ответ поиска без повторов по
 * id). Интерес из ответа Meta, который у нас уже стоит в группах, уходит в
 * первую секцию со своим числом групп — даже если наше (русское) название с
 * запросом не совпало.
 */
export function buildInterestSuggestions(input) {
    const metaIds = new Set(input.meta.map((m) => m.id));
    const usedHits = input.used.filter((u) => usedInterestMatches(u, input.query) || metaIds.has(u.id));
    const usedSection = [...usedHits]
        .sort((a, b) => b.usageCount - a.usageCount)
        .slice(0, USED_INTERESTS_SHOWN)
        .map((u) => ({
        id: u.id,
        name: u.name,
        usageCount: u.usageCount,
        group: USED_INTERESTS_GROUP,
    }));
    const seen = new Set(usedSection.map((s) => s.id));
    const metaSection = [];
    for (const m of input.meta) {
        // уже в первой секции — не дублируем; не влез в неё (предел) — остаётся здесь
        if (seen.has(m.id))
            continue;
        seen.add(m.id);
        metaSection.push({ id: m.id, name: m.name, group: META_INTERESTS_GROUP });
    }
    return [...usedSection, ...metaSection];
}
/** «в 1 группе», «в 3 группах», «в 21 группе», «в 11 группах». */
export function inAdSetsLabel(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    return `в ${n} ${mod10 === 1 && mod100 !== 11 ? 'группе' : 'группах'}`;
}
//# sourceMappingURL=interest-suggestions.js.map